// src/Components/GtagLoader/GtagLoader.tsx
import React, { useEffect } from 'react';

const MEASUREMENT_ID = 'G-1C19ZBW7HS';

export const GtagLoader: React.FC = () => {
    useEffect(() => {
        // 1. Inject gtag.js script
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
        document.head.appendChild(script);

        // 2. Define dataLayer & gtag as an arrow function
        window.dataLayer = window.dataLayer || [];
        const gtagArrow = (...args: any[]) => {
            window.dataLayer.push(args);
        };
        window.gtag = gtagArrow;

        // 3. Base initialization
        window.gtag('js', new Date().toISOString());
        window.gtag('consent', 'default', {
            analytics_storage: 'denied',
            ad_storage: 'denied',
            ad_user_data: 'denied',
            ad_personalization: 'denied',
        });
    }, []);

    return null;
};
